import { httpsCallable } from 'firebase/functions';
import { doc, onSnapshot } from 'firebase/firestore';
import { functions, db } from '../firebase/config';

export function bootstrapAdmin() {
  return httpsCallable(functions, 'bootstrapAdmin')({});
}

export function adminSendTestEmail(payload) {
  return httpsCallable(functions, 'adminSendTestEmail')(payload);
}

export function adminSendEmailBlast(payload) {
  return httpsCallable(functions, 'adminSendEmailBlast')(payload);
}

export function listenEmailProgress(progressId, onUpdate) {
  if (!progressId) return () => {};
  const ref = doc(db, 'emailProgress', progressId);
  return onSnapshot(ref, (snap) => {
    onUpdate?.(snap.exists() ? { id: snap.id, ...snap.data() } : null);
  });
}

